import React, {FC} from 'react';
import {View} from 'react-native';
import Contacts from 'react-native-contacts';

import BasePopover from '/component/base/Popover';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './ContactActionPopover.style';
import {
  checkAndroidPermissions,
  shapeContact,
} from './ContactActionPopover.util';

interface ContactActionPopoverProps {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  accountEmail: string;
  popoverClose: () => void;
}

export const ContactActionPopover: FC<ContactActionPopoverProps> = ({
  firstName = '',
  lastName = '',
  phoneNumber = '',
  accountEmail = '',
  popoverClose = () => {},
}: ContactActionPopoverProps) => {
  const {tt} = useTranslation('profile.section.contacts.action');
  const newContact = shapeContact({
    lastName,
    firstName,
    phoneNumber,
    accountEmail,
  });

  return (
    <BasePopover padded>
      <Gutter>
        <View style={styles.base}>
          <TouchableOpacity
            onPress={async () => {
              if (await checkAndroidPermissions()) {
                Contacts.openContactForm(newContact).then(() => {
                  popoverClose();
                });
              }
            }}
            accessibilityRole="button"
            accessibilityLabel={tt('createContact', 'Create New Contact')}>
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              useCompetency={true}>
              {tt('createContact', 'Create New Contact')}
            </Text>
          </TouchableOpacity>
        </View>
        {
          //TODO: Add 'Add to Existing Contact' functionality
          /*<View style={styles.bottom}>
          <TouchableOpacity onPress={() => {}}>
            <Text allowFontScaling maxFontSizeMultiplier={2} useCompetency={true}>
              {tt('addToContact', 'Add to Existing Contact')}
            </Text>
          </TouchableOpacity>
          </View>*/
        }
      </Gutter>
    </BasePopover>
  );
};
